import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const EditCourse = () => {
  const location = useLocation();
  const departmentToEdit = location.state?.course;

  const [formValues, setFormValues] = useState({
    department_id: "",
    courseCategory_id: "",
    coursename: "",
    duration: "",
    fees: "",
    price: "",
    seasonal_discount: "",
    brief: "",
    subscription_features: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [courseCategories, setCourseCategories] = useState([]);
  const [newFeature, setNewFeature] = useState("");
  const [formError, setFormError] = useState("");
  // for img and video
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [videoPreviewUrl, setVideoPreviewUrl] = useState("");
  const [courseImage, setCourseImage] = useState(null);
  const [courseVideo, setCourseVideo] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchdepartment = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/no-pagination-get-all-department`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setDepartments(response?.data.data);
        // console.log(response?.data.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchdepartment();
  }, []);

  useEffect(() => {
    const fetchCourseCategory = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-course-category-bydept/${formValues.department_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setCourseCategories(response.data.data);
        // console.log(response.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchCourseCategory();
  }, [formValues.department_id]);

  useEffect(() => {
    // console.log("departmient to editt: ", departmentToEdit);
    if (departmentToEdit) {
      setFormValues({
        department_id: departmentToEdit?.department?._id,
        courseCategory_id: departmentToEdit?.level?._id,
        coursename: departmentToEdit?.coursename,
        duration: departmentToEdit?.duration,
        fees: departmentToEdit?.fees,
        price: departmentToEdit?.price,
        seasonal_discount: departmentToEdit?.seasonal_discount,
        brief: departmentToEdit?.brief,
        subscription_features: departmentToEdit?.skills || [], // Ensure it's an array
      });
      setImagePreviewUrl(departmentToEdit?.image);
      setVideoPreviewUrl(departmentToEdit?.video);
      setLoading(false); // Stop loading after setting form state
    } else {
      setError("No course data found.");
      setLoading(false);
    }
  }, [departmentToEdit]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(loading) return;
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        // navigate("/login"); // Redirect to login if no token
        return;
      }
      

      // Validate if at least one membership feature is added
      if (formValues.subscription_features.length === 0) {
        setLoading(false);
        setSnackbarMessage("Skill required! Please add at least one before saving.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
        return;
      }
      
      setLoading(true);

      // Create FormData object
      const formData = new FormData();
      formData.append("department_id", formValues.department_id);
      formData.append("courseCategory_id", formValues.courseCategory_id);
      formData.append("coursename", formValues.coursename);
      formData.append("duration", formValues.duration);
      formData.append("fees", formValues.fees);
      formData.append("price", formValues.price);
      formData.append("seasonal_discount", formValues.seasonal_discount);
      formData.append("brief", formValues.brief);
      formData.append(
        "subscription_features",
        JSON.stringify(formValues.subscription_features)
      );

      if (courseImage) formData.append("courseImage", courseImage);
      if (courseVideo) formData.append("courseVideo", courseVideo);

      if (departmentToEdit) {
        // const response = await updateStudent(studentToEdit._id, reqBody, reqHeader);
        const response = await axios.put(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/update-course/${departmentToEdit._id}`,
          formData,
          {
            headers: { Authorization: `Bearer ${token}` },
            "Content-Type": "multipart/form-data",
          }
        );
        if (response.status === 200) {
          setSnackbarMessage("Updated successfully!");
          setSnackbarSeverity("success");
          setOpenSnackbar(true);
          setTimeout(() => {
            navigate("/courses-list");
          }, 2000);
        }
        // // console.log("edit: ", response);
      }

      //   navigate("/students");
    } catch (err) {
      setLoading(false);
      if (err.response && err.response.status === 400) {
        setSnackbarMessage("Please fill out all required fields...");
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      } else if (err.response && err.response.status === 401) {
        setSnackbarMessage("This Course name is already exists. Please check and update accordingly.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }else{
        setSnackbarMessage("Failed to update. Please try again");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    }
  };

  const handleAddFeature = (e) => {
    e.preventDefault();
    if (newFeature?.trim() === "") {
      setFormError("Feature cannot be empty.");
      return;
    }

    if (formValues?.subscription_features?.includes(newFeature.trim())) {
      setFormError("Feature already added.");
      return;
    }

    setFormValues((prevState) => ({
      ...prevState,
      subscription_features: [
        ...(prevState.subscription_features || []), // Ensure it's an array
        newFeature.trim(),
      ],
    }));

    setNewFeature(""); // Clear the input field
    setFormError(""); // Clear the error message
  };

  const handleRemoveFeature = (e, featureToRemove) => {
    e.preventDefault();
    setFormValues({
      ...formValues,
      subscription_features: formValues.subscription_features.filter(
        (feature) => feature !== featureToRemove
      ),
    });
  };

  // for handle img and video
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setCourseImage(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleVideoChange = (e) => {

    const file = e.target.files[0];
    if (file) {   
      // Revoke the old object URL to release memory
      if (videoPreviewUrl) {
        URL.revokeObjectURL(videoPreviewUrl);
      }
      const url = URL.createObjectURL(file);
      setCourseVideo(file);
      setVideoPreviewUrl(url);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        <div className="card h-100">
          <div className="card-body p-24">
          <form onSubmit={(e) => handleSubmit(e)}>
              <div className="mb-20">
                <label
                  htmlFor="depart"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Department
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  className="form-control radius-8 form-select"
                  id="depart"
                  value={formValues.department_id}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      courseCategory_id:"",
                      department_id: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select a Department
                  </option>
                  {departments.map((department) => (
                    <option key={department._id} value={department._id}>
                      {department.department_name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-20">
                <label
                  htmlFor="courseCategory"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Level
                  <span className="text-danger-600">*</span>
                </label>
                <select
                  className="form-control radius-8 form-select"
                  id="courseCategory"
                  value={formValues.courseCategory_id}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      courseCategory_id: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select Level
                  </option>
                  {courseCategories.map((courseCategory) => (
                    <option key={courseCategory._id} value={courseCategory._id}>
                      {courseCategory.courseCategoryName}
                    </option>
                  ))}
                </select>
              </div>

              {/* Course Name */}
              <div className="mb-20">
                <label
                  htmlFor="coursename"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Course Name
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter course name"
                  id="coursename"
                  className="form-control radius-8"
                  value={formValues.coursename}
                  onChange={(e) =>
                    {
                      const value = e.target.value;
                    if (value === "" || value.trim() !== "") {
                      setFormValues({
                      ...formValues,
                      coursename: e.target.value,
                    })}}
                  }
                  required
                />
              </div>

              {/* Duration */}
              <div className="mb-20">
                <label
                  htmlFor="duration"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Duration (In Weeks)
                  <span className="text-danger-600">*</span>
                </label>
                <input 
                required
                  type="number"
                  id="duration"
                  placeholder="Enter course duration"
                  className="form-control radius-8"
                  value={formValues.duration}
                  onChange={(e) =>
                    setFormValues({
                      ...formValues,
                      duration: e.target.value,
                    })
                  }
                 
                />
              </div>

              {/* Fees */}
              <div className="mb-20">
                <label
                  htmlFor="fees"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Fees
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  type="number"
                  id="fees"
                  placeholder="Enter fees"
                  className="form-control radius-8"
                  value={formValues.fees}
                  onChange={(e) =>
                    setFormValues({ ...formValues, fees: e.target.value })
                  }
                  required
                />
              </div>
              {/* Fees */}
              <div className="mb-20">
                <label
                  htmlFor="price"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Price
                  <span className="text-danger-600">*</span>
                </label>
                <input
                  type="number"
                  id="price"
                  placeholder="Enter price"
                  className="form-control radius-8"
                  value={formValues.price}
                  onChange={(e) =>
                    setFormValues({ ...formValues, price: e.target.value })
                  }
                  required
                />
              </div>
              

              {/* seasonal_discount */}
              <div className="mb-20">
                <label
                  htmlFor="seasonal_discount"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Seasonal Discount(%)
                </label>
                <input
                 placeholder="Enter seasonal discount (optional)"
                  type="number"
                  id="seasonal_discount"
                  className="form-control radius-8"
                  value={formValues.seasonal_discount}
                  onChange={(e) =>
                    setFormValues({ ...formValues, seasonal_discount: e.target.value })
                  }
                />
              </div>

              {/* Brief */}
              <div className="mb-20">
                <label
                  htmlFor="brief"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Brief
                  <span className="text-danger-600">*</span>
                </label>
                <textarea
                  id="brief"
                  placeholder="Enter brief"
                  className="form-control radius-8"
                  value={formValues.brief}
                  onChange={(e) =>{
                    const value = e.target.value;
                    if (value === "" || value.trim() !== "") {
                      setFormValues({
                        ...formValues, brief: e.target.value  });
                      }
                    }}
                  required
                />
              </div>

              <div className="mb-20">
                <label
                  htmlFor="courseImage"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Course Image
                </label>
                <div className="upload-field">
                  <input
                    type="file"
                    id="courseImage"
                    accept="image/*"
                    onChange={handleImageChange}
                    className="d-none"
                  />
                  {/* Buttons container */}
                  <div className="d-flex gap-2 mb-2">
                    <button
                      type="button"
                      onClick={() =>
                        document.getElementById("courseImage").click()
                      }
                      className="btn btn-outline-primary"
                    >
                      <i className="fas fa-upload me-2"></i>
                      Upload Image
                    </button>

                    {/* {imagePreviewUrl && (
                      <button
                        type="button"
                        onClick={() => {
                          setImagePreviewUrl(null);
                          document.getElementById("courseImage").value = "";
                        }}
                        className="btn btn-outline-danger"
                      >
                        <i className="fas fa-trash me-2"></i>
                        Remove Image
                      </button>
                    )} */}
                  </div>
                  {imagePreviewUrl ? (
                    <div className="mt-2">
                      <img
                        src={imagePreviewUrl}
                        alt="Course Preview"
                        className="img-thumbnail"
                        style={{ maxHeight: "200px" }}
                      />
                    </div>
                  ) : (
                    <div className="text-muted small"></div>
                  )}
                </div>
              </div>

              <div className="mb-20">
                <label
                  htmlFor="courseVideo"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Course Video
                </label>
                <div className="upload-field">
                  {/* Hidden file input */}
                  <input
                    type="file"
                    id="courseVideo"
                    accept="video/*"
                    onChange={handleVideoChange}
                    className="d-none"
                  />
                  {/* Buttons container */}
                  <div className="d-flex gap-2 mb-2">
                    <button
                      type="button"
                      onClick={() =>
                        document.getElementById("courseVideo").click()
                      }
                      className="btn btn-outline-primary"
                    >
                      <i className="fas fa-upload me-2"></i>
                      Upload Video
                    </button>


                    {/* {videoPreviewUrl && (
                      <button
                        type="button"
                        onClick={() => {
                          setVideoPreviewUrl(null);
                          // Reset the file input
                          document.getElementById("courseVideo").value = "";
                        }}
                        className="btn btn-outline-danger"
                      >
                        <i className="fas fa-trash me-2"></i>
                        Remove Video
                      </button>
                    )} */}
                  </div>
                  {videoPreviewUrl && (
                    <div className="mt-2">
                      <video
                        controls
                        className="w-100"
                        style={{ maxHeight: "200px" }}
                        src={videoPreviewUrl}
                      >
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  )}
                </div>
              </div>


              <div className="mb-24">
                <label
                  htmlFor="subscription_features"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Add Skills <span className="text-danger-600">*</span>
                </label>
                <input
                placeholder="Enter a skill"
                  className="form-control radius-8"
                  id="subscription_features"
                  value={newFeature}
                  onChange={(e) => setNewFeature(e.target.value)}
                />
                {formError && (
                  <div className="text-danger-600">{formError}</div>
                )}

                {/* Add Button */}
                <button
                  className="btn btn-outline-primary mt-2"
                  onClick={handleAddFeature}
                  disabled={loading || newFeature?.trim() === ""}
                >
                  +
                </button>

                {/* Display Added Features */}
                <div className="mt-3">
                  <p>Added Features:</p>
                  <div className="d-flex flex-wrap">
                    {formValues?.subscription_features?.map(
                      (feature, index) => (
                        <div
                          key={index}
                          className="chip"
                          style={{
                            color: "black",
                            marginRight: "8px",
                            marginBottom: "8px",
                            backgroundColor: "#f0f0f0",
                            padding: "6px 12px",
                            borderRadius: "16px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <span>{feature}</span>
                          <button
                            className="btn btn-sm btn-danger ml-2"
                            onClick={(e) => handleRemoveFeature(e, feature)}
                            style={{
                              borderRadius: "50%",
                              padding: "0 6px",
                              fontSize: "14px",
                            }}
                          >
                            x
                          </button>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-center gap-3">
                <button
                  type="button"
                  className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                  onClick={() => navigate("/courses-list")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                  // onClick={handleSubmit}
                >
                  {loading && (
                    <div
                      className="loader-container"
                      style={styles.loaderContainer}
                    >
                      <CircularProgress />
                    </div>
                  )}
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          // variant="filled"
          // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default EditCourse;
